const LIMITS = {
    MAX_CATALOGUE_LIMIT: 3,
    MAX_ADMIN_LIMIT: 10,
}

export default LIMITS;